export default __webpack_public_path__ + "static/media/search_icon.c966a2e3.svg";